// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__S8e5P","ThumbZoom":"ChapterPlayer_ThumbZoom__2vb8L"};